import React, { useEffect, useState } from 'react'
import Heading from 'presentation/shared/components/Heading'
import ActualPage from 'presentation/shared/components/ActualPage'
import { useHistory, useLocation } from 'react-router-dom'
import { ReactComponent as PinIcon } from 'presentation/assets/icons/pin-icon.svg'
import { ReactComponent as CalendarIcon } from 'presentation/assets/icons/calendar-icon.svg'
import TextArea from 'presentation/shared/components/TextArea'
import AdvancedButton from 'presentation/shared/components/AdvancedButton'
import {
  DocumentItem,
  DocumentsAreaModal
} from 'presentation/shared/components/DocumentsArea/DocumentsAreaModal'
import { toast } from 'react-toastify'
import { dateMask, phoneMask } from 'presentation/utils/masks'
import { documentAuthorizationGuide } from 'presentation/shared/pages/SurgeryDetails/documents'
import { FormikProvider, useFormik, useFormikContext } from 'formik'
import { useServices } from 'presentation/hooks/use-services'
import { PatientDocument } from 'common/enum/patient-document'
import { renameFile } from 'common/utils/file/renameFile'
import moment from 'moment'
import LoadingModal from 'presentation/shared/components/LoadingModal'
import DateRange from '@material-ui/icons/DateRange'
import { getNameInitials } from 'common/utils/getNameInitials'
import { SurgicalOrderModel } from 'domain/entities/surgical-order-model'
import { SurgicalOrderProcedureModel } from 'domain/entities/surgical-order-procedure-model'
import CheckboxNew from 'presentation/shared/components/CheckboxNew'
import RadioButtonNew from 'presentation/shared/components/RadioButtonNew'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import { OPMEStatus, OPMEStatusTranslated } from 'common/enum/opme-status'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import { LoadSurgicalOrderDocument } from 'domain/usecases/surgical-order/load-surgical-order-document'
import validationSchema from './validationSchema'
import * as S from './styles'
import {
  getAuthorizationGuideDocument,
  buildAuthorizationGuideFile
} from './utils'
import SelectFieldNew from 'presentation/shared/components/SelectFieldNew'
import {
  AuthorizationStatus,
  AuthorizationStatusTranslated
} from 'common/enum/authorization-status'
import { ActionsPendency } from 'common/enum/actions-pendency'
import { PendencyType } from 'domain/entities/surgical-pendency'
import { formatObservations } from 'common/utils/formatObservations'
import { sanitizeControlChars } from 'common/utils/sanitizeControlChars'
import TabsNew from 'presentation/shared/components/TabsNew'
import AccordionTest from 'presentation/shared/components/AccordionTest'
import { ReactComponent as PencilIcon } from 'presentation/assets/icons/pencil-icon.svg'
import { WithLoading } from 'presentation/shared/components/HOCs/WithLoading'
import { Profile } from 'common/enum/profile'
import { FinalizedOrderType } from 'domain/usecases/surgical-order/get-finalize-surgical-orders-history'
import { formatGuideObservations } from 'common/utils/formatGuideObservations'

type OrderProps = {
  order: {
    color: string
    type: string
    status: string
    title: string
    unit: string
    date: string
    orderId: string
    patientName: string
    procedure: SurgicalOrderProcedureModel[]
    doctorName: string
  }
}

type FinishOrderFormValues = {
  // finished_order: boolean
  notify: {
    patient?: {
      byEmail: boolean
      bySms: boolean
    }
    doctor?: {
      byEmail: boolean
      bySms: boolean
    }
    secretary?: {
      byEmail: boolean
      bySms: boolean
    }
  }
  email: {
    patient: string
    doctor: string
    secretary: string
  }
  phone: {
    patient: string
    doctor: string
    secretary: string
  }

  password?: string
  passwordValidUntil: {
    date?: string
    text?: string
  }
  // procedures?: SurgicalOrderProcedureModel[]
  procedures?: any
  proceduresObservation: string
  opmeVerification: OPMEStatusTranslated | string
  opmeObservation: string
  // opme?: SurgicalOrderOpmeModel
  opme?: any
  generalObservations: string
  documents_attached: any[]
  health_insurance_code?: number
  active_status?: AuthorizationStatus | string
}

type FinishOrderProps = {
  goBack?: any
  guidesTypeProcedures?: any
  guidesTypeOpme?: any
  uploadSurgicalOrderDocument?: any
  loadSurgicalOrderDocument?: LoadSurgicalOrderDocument
  updateSurgicalOrder?: any
  surgicalOrder: SurgicalOrderModel
  finalizedOrders: FinalizedOrderType[]
}

export const FinishOrderEdit = ({
  goBack,
  guidesTypeProcedures,
  guidesTypeOpme,
  surgicalOrder,
  loadSurgicalOrderDocument,
  finalizedOrders
}: FinishOrderProps) => {
  const surgicalOrderService = useServices().surgicalOrder
  const surgicalOrderGuideService = useServices().surgicalOrderGuide
  const surgicalPendencyService = useServices().surgicalPendency
  const orderData = useLocation() as any
  const history = useHistory()
  const order = orderData.state.surgery
  const [isLoading, setIsLoading] = useState(false)
  const [opme, setOpme] = useState({}) as any
  const [guideObservations, setGuideObservations] = useState({
    procedures: '',
    opme: ''
  })
  const finishedOrder = !!surgicalOrder?.finalized
  const [canEditForm, setCanEditForm] = useState<boolean>(!finishedOrder)

  useEffect(() => {
    const loadObservationsFromGuides = async (orderId: number) => {
      try {
        const { procedures, opme } =
          await surgicalOrderGuideService.loadSurgicalOrderGuidesObservations(
            orderId
          )
        setGuideObservations({
          procedures: formatGuideObservations(procedures, 'PROCEDIMENTO'),
          opme: formatGuideObservations(opme, 'OPME', true)
        })
      } catch (error) {
        setGuideObservations({ procedures: '', opme: '' })
      }
    }

    if (surgicalOrder?.surgical_order_id) {
      loadObservationsFromGuides(surgicalOrder.surgical_order_id)
    }
  }, [surgicalOrder?.surgical_order_id])

  function getLastFinalizedOrder() {
    if (finalizedOrders?.length === 1) {
      return finalizedOrders[0]
    } else if (finalizedOrders?.length > 1) {
      return finalizedOrders.filter((finalizedOrder: any) => {
        return finalizedOrder.is_active === true
      })[0]
    }
  }
  let proceduresFromMV = [
    {
      password: '',
      date: '',
      details: []
    }
  ]

  if (guidesTypeProcedures.length > 0) {
    proceduresFromMV = guidesTypeProcedures?.map((guideProcedure: any) => {
      const date = moment.utc(guideProcedure?.date)

      return {
        password: guideProcedure?.password,
        date: date.isValid() ? date.format('DD/MM/YYYY') : null,
        details: guideProcedure?.details
      }
    })
  }

  const getNormalizedProceduresData = () => {
    const guidesTypeProceduresFromMVItems = proceduresFromMV[0]?.details?.map(
      (item: any) => {
        return {
          code: item?.fat_id,
          description: item?.procedure,
          quantity_solicitation: item?.quantity_solicitation,
          quantity_authorization: item?.quantity_authorization
        }
      }
    )

    // 1) Guias do MV (fonte primária)
    if (guidesTypeProceduresFromMVItems?.length) {
      return guidesTypeProceduresFromMVItems
    }

    // 2) Fallback: snapshot da finalização (banco)
    if (surgicalOrder?.finalized?.procedure?.length) {
      return surgicalOrder.finalized.procedure.map((item: any) => {
        return {
          code: item?.code,
          description: item?.description,
          quantity_solicitation: item?.quantity,
          quantity_authorization: item?.quantity_authorized
        }
      })
    }

    // 3) Fallback: procedimentos do pedido (não finalizado, sem qtd. autorizada)
    if (surgicalOrder?.procedure?.length) {
      return surgicalOrder.procedure.map((item: any) => {
        return {
          code: item?.code,
          description: item?.description,
          quantity_solicitation: item?.quantity,
          quantity_authorization: item?.quantity_authorized
        }
      })
    }

    return guidesTypeProceduresFromMVItems
  }

  const getNormalizedOPMEData = () => {
    const guidesTypeOPMEFromMVItems: any = guidesTypeOpme[0]?.details?.map(
      (item: any) => {
        return {
          code: item?.fat_id,
          description: item?.procedure,
          provider: item?.provider ?? '',
          quantity_solicitation: item?.quantity_solicitation,
          quantity_authorization: item?.quantity_authorization
        }
      }
    )

    // 1) Guias do MV (fonte primária)
    if (guidesTypeOPMEFromMVItems?.length) {
      return guidesTypeOPMEFromMVItems
    }

    // 2) Fallback: OPME da finalização (banco) — formato novo
    if (surgicalOrder?.finalized?.opme_new?.length) {
      return surgicalOrder.finalized.opme_new.map((item: any) => {
        return {
          code: item?.code,
          description: item?.description,
          provider: item?.provider ?? '',
          quantity_solicitation: item?.quantity,
          quantity_authorization: item?.quantity_authorized
        }
      })
    }

    // 2b) Fallback: OPME da finalização (formato legado)
    if (surgicalOrder?.finalized?.opme?.solicitations?.length) {
      const providers = surgicalOrder.finalized.opme.providers
        ?.toString()
        ?.replaceAll(',', ', ')
      return surgicalOrder.finalized.opme.solicitations.map((item: any) => {
        return {
          code: item?.code,
          description: item?.description,
          provider: providers ?? '',
          quantity_solicitation: item?.quantity,
          quantity_authorization: item?.quantity_authorized
        }
      })
    }

    // 3) Fallback: OPME do pedido (não finalizado, sem qtd. autorizada)
    if (surgicalOrder?.opme?.solicitations?.length) {
      const providers = surgicalOrder.opme.providers
        ?.toString()
        ?.replaceAll(',', ', ')
      return surgicalOrder.opme.solicitations.map((item: any) => {
        return {
          code: item?.code,
          description: item?.description,
          provider: providers ?? '',
          quantity_solicitation: item?.quantity,
          quantity_authorization: item?.quantity_authorized
        }
      })
    }

    return guidesTypeOPMEFromMVItems
  }

  // const getNormalizedPassword = () => {
  //   // Pedido não Finalizado ou Finalizado e em modo de edição:
  //   if (!getLastFinalizedOrder() || (getLastFinalizedOrder() && canEditForm))
  //     return proceduresFromMV[0]?.password ?? ''

  //   // Pedido finalizado e em modo de visualização:
  //   return getLastFinalizedOrder()?.password_to_finish ?? ''
  // }

  // const getNormalizedPasswordValidUntil = () => {
  //   // Pedido não Finalizado ou Finalizado e em modo de edição:
  //   if (!getLastFinalizedOrder() || (getLastFinalizedOrder() && canEditForm))
  //     return {
  //       date: proceduresFromMV[0]?.date ?? '',
  //       text: getLastFinalizedOrder()?.password_max_string_validation ?? ''
  //     }

  //   // Pedido finalizado e em modo de visualização:
  //   return {
  //     date:
  //       moment(getLastFinalizedOrder()?.password_max_date_validation).format(
  //         'DD/MM/YYYY'
  //       ) ?? null,
  //     text: getLastFinalizedOrder()?.password_max_string_validation ?? ''
  //   }
  // }

  let contactValues

  if (finalizedOrders?.length >= 1) {
    contactValues = {
      phone: {
        patient: getLastFinalizedOrder()?.notify?.patient.phone || '',
        doctor: getLastFinalizedOrder()?.notify?.doctor.phone || '',
        secretary: getLastFinalizedOrder()?.notify?.secretary.phone || ''
      },

      email: {
        patient: getLastFinalizedOrder()?.notify?.patient.email || '',
        doctor: getLastFinalizedOrder()?.notify?.doctor.email || '',
        secretary: getLastFinalizedOrder()?.notify?.secretary.email || ''
      }
    }
  } else {
    contactValues = {
      phone: {
        patient: surgicalOrder?.patient?.phone || '',
        doctor: surgicalOrder?.doctor?.phone || '',
        secretary: ''
      },

      email: {
        patient: surgicalOrder?.patient?.email || '',
        doctor: surgicalOrder?.doctor?.email || '',
        secretary: ''
      }
    }
  }

  const authorizationGuideDocument = getAuthorizationGuideDocument(
    getLastFinalizedOrder()?.document,
    surgicalOrder
  )

  const formik = useFormik<FinishOrderFormValues>({
    initialValues: {
      notify: {
        patient: {
          byEmail:
            getLastFinalizedOrder()?.notify?.patient.is_notify_email || false,
          bySms:
            getLastFinalizedOrder()?.notify?.patient.is_notify_phone || false
        },
        doctor: {
          byEmail:
            getLastFinalizedOrder()?.notify?.doctor.is_notify_email || false,
          bySms:
            getLastFinalizedOrder()?.notify?.doctor.is_notify_phone || false
        },
        secretary: {
          byEmail:
            getLastFinalizedOrder()?.notify?.secretary.is_notify_email || false,
          bySms:
            getLastFinalizedOrder()?.notify?.secretary.is_notify_phone || false
        }
      },

      phone: contactValues.phone,
      email: contactValues.email,
      active_status: [
        AuthorizationStatusTranslated.AUTHORIZED,
        AuthorizationStatusTranslated.PARTIALLY_AUTHORIZED,
        AuthorizationStatusTranslated.DENIED
      ].includes(surgicalOrder?.active_status as AuthorizationStatusTranslated)
        ? surgicalOrder.active_status
        : '',
      password: guidesTypeProcedures[0]?.password || '',

      passwordValidUntil: {
        date: moment(guidesTypeProcedures[0]?.date)?.format('DD/MM/YYYY'),
        text:
          (finalizedOrders?.length > 0 &&
            getLastFinalizedOrder()?.password_max_string_validation) ||
          ''
      },
      procedures: getNormalizedProceduresData(),
      proceduresObservation:
        getLastFinalizedOrder()?.procedure_observation ||
        guideObservations.procedures ||
        '',
      opme: getNormalizedOPMEData() || [],
      opmeVerification: getLastFinalizedOrder()?.opme_details || '',
      opmeObservation:
        getLastFinalizedOrder()?.opme_observation ||
        guideObservations.opme ||
        '',
      generalObservations: getLastFinalizedOrder()?.general_observation || '',
      documents_attached:
        canEditForm || !authorizationGuideDocument
          ? []
          : [authorizationGuideDocument],
      health_insurance_code: surgicalOrder?.healthInsurance?.healthInsuranceCode
    },
    validationSchema: validationSchema,

    onSubmit: async (values) => {
      const formatAuthorizationStatus = () => {
        if (!values.active_status) return undefined
        switch (values.active_status) {
          case AuthorizationStatusTranslated.AUTHORIZED:
            return AuthorizationStatus.AUTHORIZED
          case AuthorizationStatusTranslated.PARTIALLY_AUTHORIZED:
            return AuthorizationStatus.PARTIALLY_AUTHORIZED
          default:
            return AuthorizationStatus.DENIED
        }
      }

      try {
        setIsLoading(true)

        // Sanitiza os campos de texto livre antes de enviar ao MV: remove
        // caracteres de controle invisíveis (ex.: U+0013) colados de outros
        // sistemas, que quebram a tela de registro de contato do MV.
        const observation = sanitizeControlChars(values.generalObservations)
        const procedureDetails = sanitizeControlChars(
          values.proceduresObservation
        )
        const opmeDetails = sanitizeControlChars(values.opmeVerification)
        const opmeObservation = sanitizeControlChars(values.opmeObservation)
        const passwordToFinish = sanitizeControlChars(values.password)
        const passwordMaxStringValidation = sanitizeControlChars(
          values.passwordValidUntil.text
        )

        const form = new FormData()

        if (values?.documents_attached[0]?.file) {
          const type = PatientDocument.AUTHORIZATION_GUIDE

          const renamedFile = renameFile(
            values?.documents_attached[0]?.file,
            type,
            {
              forceOriginalExtension: true
            }
          )

          form.append('file', renamedFile)
        }

        form.append(
          'notify[patient][is_notify_email]',
          `${values.notify.patient?.byEmail}`
        )

        form.append(
          'notify[patient][is_notify_phone]',
          `${values.notify.patient?.bySms}`
        )
        form.append('notify[patient][email]', `${values.email?.patient}`)
        form.append('notify[patient][phone]', `${values.phone.patient}`)

        form.append(
          'notify[doctor][is_notify_email]',
          `${values.notify.doctor?.byEmail}`
        )
        form.append(
          'notify[doctor][is_notify_phone]',
          `${values.notify.doctor?.bySms}`
        )
        form.append('notify[doctor][email]', `${values.email?.doctor}`)
        form.append('notify[doctor][phone]', `${values.phone.doctor}`)

        form.append(
          'notify[secretary][is_notify_email]',
          `${values.notify.secretary?.byEmail}`
        )
        form.append(
          'notify[secretary][is_notify_phone]',
          `${values.notify.secretary?.bySms}`
        )
        form.append('notify[secretary][email]', `${values.email?.secretary}`)
        form.append('notify[secretary][phone]', `${values.phone.secretary}`)

        form.append('surgical_order_id', `${surgicalOrder.surgical_order_id}`)
        form.append('observation', `${observation}`)
        form.append('procedures', `${JSON.stringify(values.procedures)}`)
        form.append('procedure_details', `${procedureDetails}`)
        form.append('opme_details', `${opmeDetails}`)
        form.append('opme', `${JSON.stringify(values.opme)}`)
        form.append('opme_observation', `${opmeObservation}`)
        form.append('password_to_finish', `${passwordToFinish}`)
        form.append(
          'password_max_date_validation',
          `${moment(
            values.passwordValidUntil.date,
            'DD/MM/YYYY'
          ).toISOString()}`
        )
        form.append(
          'password_max_string_validation',
          `${passwordMaxStringValidation}`
        )
        form.append('status', `${formatAuthorizationStatus()}`)

        const authorizationStatus = formatAuthorizationStatus()
        await surgicalOrderService.editFinalizeSurgicalOrder({ form })

        if (authorizationStatus === AuthorizationStatus.PARTIALLY_AUTHORIZED) {
          try {
            const observationText = formatObservations(
              procedureDetails,
              opmeObservation,
              surgicalOrder.doctor?.name || ''
            )

            const pendencyPayload = {
              doctor_id: surgicalOrder.doctor?.doctor_id,
              patient_id: surgicalOrder.patient?.patient_id,
              notify: {
                doctor:
                  values.notify.doctor?.byEmail ||
                  values.notify.doctor?.bySms ||
                  false,
                secretary:
                  values.notify.secretary?.byEmail ||
                  values.notify.secretary?.bySms ||
                  false,
                patient:
                  values.notify.patient?.byEmail ||
                  values.notify.patient?.bySms ||
                  false
              },
              notifyBy: {
                whatsapp: true,
                email: true,
                platform: true
              },
              email: {
                doctor: values.email?.doctor || '',
                secretary: values.email?.secretary || '',
                patient: values.email?.patient || ''
              },
              phone: {
                doctor: values.phone.doctor
                  ? values.phone.doctor.replace(/\D+/g, '')
                  : '',
                patient: values.phone.patient
                  ? values.phone.patient.replace(/\D+/g, '')
                  : '',
                secretary: values.phone.secretary
                  ? values.phone.secretary.replace(/\D+/g, '')
                  : ''
              },
              surgical_order_id: surgicalOrder.surgical_order_id!,
              type: PendencyType.AUTHORIZATION,
              action: ActionsPendency.CRMO_CREATED_PENDENCY_AUTH_DIVERGENCE,
              observation: observationText
            }

            await surgicalPendencyService.addSurgicalPendency(pendencyPayload)
          } catch (pendencyError: any) {
            console.error('Erro ao criar pendência automática:', pendencyError)
          }
        }

        setIsLoading(false)
        toast.success('Pedido finalizado!')
        history.goBack()
      } catch (err: any) {
        toast.error(err.message)
        return
      } finally {
        setIsLoading(false)
      }
    },
    enableReinitialize: true
  })

  // const showToastError = () => toast.error('Verifique os campos do formulário')

  const handleSubmitForm = async () => {
    setTabVisible(false)
    setEditMode(true)
    if (!canEditForm) return setCanEditForm(true)
    // await formik.submitForm()
    // if (!formik.isValid) return showToastError()
  }

  const [editMode, setEditMode] = useState(false)

  const finalizedOrUpdatedByName =
    !!surgicalOrder.finalized?.lastUpdateUser &&
    surgicalOrder.finalized?.lastUpdateUser?.name
  const finalizedOrUpdatedByRole =
    !!surgicalOrder.finalized?.lastUpdateUser &&
    surgicalOrder.finalized?.lastUpdateUser?.role
  const finalizedOrUpdatedByDate = surgicalOrder.finalized?.updated_at

  const tabItems = [
    {
      label: 'Última finalização',
      componentChildren: (
        <div style={{ minWidth: '1140px', paddingRight: '20px' }}>
          <div style={{ paddingTop: '50px' }}></div>

          <S.LineDivider />
          <S.AuthorizedSection>
            <SupportTextNew weight="semiBold" size="xlarge" color="neutral800">
              {/* TODO: Texto vem direto do backend, substituir por ENUM */}
              Pedido {order?.status}
            </SupportTextNew>

            <SupportTextNew size="xsmall" weight="normal">
              Editado por: &nbsp;
              {finalizedOrUpdatedByRole === Profile.DOCTOR && 'Dr.(a) '}
              {finalizedOrUpdatedByName} em{' '}
              {moment(finalizedOrUpdatedByDate)
                .utc()
                .format(`DD [de] MMM[.] [de] YYYY [às] HH[h]mm`)}
            </SupportTextNew>
          </S.AuthorizedSection>
          <S.LineDivider />

          <FormSection
            formik={formik}
            canEditForm={canEditForm}
            setCanEditForm={setCanEditForm}
            surgicalOrder={surgicalOrder}
            opme={opme}
            setOpme={setOpme}
            loadSurgicalOrderDocument={loadSurgicalOrderDocument}
            finishedOrder={getLastFinalizedOrder()}
            editMode={editMode}
            setEditMode={setEditMode}
          />
        </div>
      )
    },
    {
      label: 'Histórico de finalizações',
      componentChildren: (
        <div
          style={{
            minWidth: '1140px'
          }}
        >
          <div style={{ paddingTop: '40px' }}></div>
          <AllFinishedOrders
            finalizedOrders={finalizedOrders}
            formik={formik}
            canEditForm={canEditForm}
            setCanEditForm={setCanEditForm}
            surgicalOrder={surgicalOrder}
            opme={opme}
            setOpme={setOpme}
            loadSurgicalOrderDocument={loadSurgicalOrderDocument}
            finishedOrder={finishedOrder}
            order={order}
          />
        </div>
      )
    }
  ]

  // const { submitForm, isSubmitting, isValid } =
  //   useFormikContext<FinishOrderFormValues>()

  // const showToastError = () => toast.error('Verifique os campos do formulário')

  // const handleSubmitForm = async () => {
  //   if (!canEditForm) return setCanEditForm(true)
  //   await submitForm()
  //   if (!isValid) return showToastError()
  // }

  const [tabVisible, setTabVisible] = useState(true)

  return (
    <>
      <S.Wrapper>
        <ActualPage
          style={{ marginTop: '40px', marginBottom: '30px' }}
          text={'Voltar'}
          onClick={goBack}
        />
        <Heading
          style={{ marginBottom: '35px' }}
          size="xlarge"
          color="primary"
          as="h1"
        >
          Finalização do pedido
        </Heading>
        <OrderCard order={order} />

        {(finalizedOrders.length > 0 && tabVisible) || !canEditForm ? (
          <div>
            {surgicalOrder.active_status !==
              AuthorizationStatusTranslated.CANCELED &&
              surgicalOrder.active_status !==
                AuthorizationStatusTranslated.DONE && (
                <>
                  <S.EditButtonContainer>
                    <ButtonNew
                      onClick={handleSubmitForm}
                      disabled={formik.isSubmitting}
                    >
                      <PencilIcon />
                      <p>Editar dados de finalização</p>
                    </ButtonNew>
                  </S.EditButtonContainer>
                </>
              )}

            <S.OrderContainer>
              <div style={{ display: 'contents' }}>
                <TabsNew tabItems={tabItems} />
              </div>
            </S.OrderContainer>
          </div>
        ) : (
          <>
            {editMode && (
              <SupportTextNew
                weight="semiBold"
                size="xlarge"
                color="neutral800"
                style={{ marginBottom: '18px' }}
              >
                Editar dados de finalização do pedido
              </SupportTextNew>
            )}

            <FormSection
              formik={formik}
              canEditForm={canEditForm}
              setCanEditForm={setCanEditForm}
              surgicalOrder={surgicalOrder}
              opme={opme}
              setOpme={setOpme}
              loadSurgicalOrderDocument={loadSurgicalOrderDocument}
              finishedOrder={getLastFinalizedOrder()}
              finalizedOrders={finalizedOrders}
              editMode={editMode}
              setEditMode={setEditMode}
            />
          </>
        )}
      </S.Wrapper>
      <LoadingModal show={isLoading} />
    </>
  )
}

const OrderCard = ({ order }: OrderProps) => {
  return (
    <>
      <S.CardWrapper>
        <S.CardHeader>
          <strong>{order?.type}</strong>
          <S.StatusTag color={order?.color}>
            <span>{order?.status}</span>
          </S.StatusTag>
        </S.CardHeader>
        <S.SurgeryTitle>{order?.title}</S.SurgeryTitle>
        <S.CardBody>
          <S.Strong>
            <PinIcon /> &nbsp; Hospital {order?.unit}
          </S.Strong>
          <S.Strong>
            <CalendarIcon /> &nbsp;{' '}
            {moment(order?.date).utc().format('DD/MM/YYYY - HH:mm')}
          </S.Strong>
          <S.Strong>N° Aviso: {order?.orderId}</S.Strong>
        </S.CardBody>
        <S.CardFooter>
          <S.Strong>
            <S.GreenStrong>Paciente: &nbsp;</S.GreenStrong>
            {order?.patientName}
          </S.Strong>
          <S.Strong>
            <S.GreenStrong>Médico responsável: &nbsp;</S.GreenStrong>
            {order?.doctorName}
          </S.Strong>
        </S.CardFooter>
      </S.CardWrapper>
    </>
  )
}

const NotificationOptions = ({ canEditForm, finishedOrder }: any) => {
  const { handleChange, values, errors, touched, handleBlur } =
    useFormikContext<FinishOrderFormValues>()

  return (
    <>
      <S.OrderContainer>
        <S.GreenLabel>Notificar via:</S.GreenLabel>
        <S.SubTitle>Paciente</S.SubTitle>
        <S.ProfileWrapper>
          <S.InputBlock>
            <S.CheckboxWrapper>
              <CheckboxNew
                label="E-mail"
                labelFor="notify_patient_email"
                labelSize="xsmall"
                name="notify.patient.byEmail"
                checked={
                  canEditForm
                    ? values.notify?.patient?.byEmail
                    : finishedOrder?.notify?.patient?.is_notify_email
                }
                onChange={handleChange}
                disabled={!canEditForm}
              />
            </S.CheckboxWrapper>
            <TextFieldNew
              placeholder="E-mail"
              id="email"
              name="email.patient"
              onChange={handleChange}
              error={touched.email?.patient && errors.email?.patient}
              onBlur={handleBlur}
              defaultValue={
                canEditForm
                  ? values.email?.patient
                  : finishedOrder?.notify?.patient?.email
              }
              disabled={!canEditForm}
            />
          </S.InputBlock>
          <S.InputBlock>
            <S.CheckboxWrapper>
              <CheckboxNew
                label="SMS"
                labelFor="notify_patient_sms"
                labelSize="xsmall"
                name="notify.patient.bySms"
                checked={
                  canEditForm
                    ? values.notify.patient?.bySms
                    : finishedOrder?.notify?.patient?.is_notify_phone
                }
                onChange={handleChange}
                disabled={!canEditForm}
              />
            </S.CheckboxWrapper>
            <TextFieldNew
              placeholder="(31)99999-9999"
              mask={phoneMask}
              id="fone"
              name="phone.patient"
              error={touched.phone?.patient && errors.phone?.patient}
              onChange={handleChange}
              onBlur={handleBlur}
              defaultValue={
                canEditForm
                  ? values.phone?.patient
                  : finishedOrder?.notify?.patient?.phone
              }
              disabled={!canEditForm}
            />
          </S.InputBlock>
        </S.ProfileWrapper>
        <S.SubTitle>Médico</S.SubTitle>
        <S.ProfileWrapper>
          <S.InputBlock>
            <S.CheckboxWrapper>
              <CheckboxNew
                label="E-mail"
                labelSize="xsmall"
                labelFor="notify_doctor_email"
                name="notify.doctor.byEmail"
                checked={
                  canEditForm
                    ? values.notify.doctor?.byEmail
                    : finishedOrder?.notify?.doctor?.is_notify_email
                }
                onChange={handleChange}
                disabled={!canEditForm}
              />
            </S.CheckboxWrapper>
            <TextFieldNew
              placeholder="E-mail"
              id="email"
              name="email.doctor"
              onChange={handleChange}
              error={touched.email?.doctor && errors.email?.doctor}
              onBlur={handleBlur}
              defaultValue={values.email?.doctor}
              disabled={!canEditForm}
            />
          </S.InputBlock>
          <S.InputBlock>
            <S.CheckboxWrapper>
              <CheckboxNew
                label="SMS"
                labelSize="xsmall"
                labelFor="notify_doctor_sms"
                name="notify.doctor.bySms"
                checked={
                  canEditForm
                    ? values.notify.doctor?.bySms
                    : finishedOrder?.notify?.doctor?.is_notify_phone
                }
                onChange={handleChange}
                disabled={!canEditForm}
              />
            </S.CheckboxWrapper>
            <TextFieldNew
              placeholder="(31)99999-9999"
              mask={phoneMask}
              id="fone"
              error={touched.phone?.doctor && errors.phone?.doctor}
              name="phone.doctor"
              onChange={handleChange}
              onBlur={handleBlur}
              defaultValue={
                canEditForm
                  ? values.phone?.doctor
                  : finishedOrder?.notify?.doctor?.phone
              }
              disabled={!canEditForm}
            />
          </S.InputBlock>
        </S.ProfileWrapper>
        <S.SubTitle>Secretária</S.SubTitle>
        <S.ProfileWrapper>
          <S.InputBlock>
            <S.CheckboxWrapper>
              <CheckboxNew
                label="E-mail"
                labelSize="xsmall"
                labelFor="notify_secretary_email"
                name="notify.secretary.byEmail"
                checked={
                  canEditForm
                    ? values.notify.secretary?.byEmail
                    : finishedOrder?.notify?.secretary?.is_notify_email
                }
                onChange={handleChange}
                disabled={!canEditForm}
              />
            </S.CheckboxWrapper>
            <TextFieldNew
              placeholder="E-mail"
              id="email"
              name="email.secretary"
              error={touched.email?.secretary && errors.email?.secretary}
              onChange={handleChange}
              onBlur={handleBlur}
              defaultValue={
                canEditForm
                  ? values.email?.secretary
                  : finishedOrder?.notify?.secretary.email
              }
              disabled={!canEditForm}
            />
          </S.InputBlock>
          <S.InputBlock>
            <S.CheckboxWrapper>
              <CheckboxNew
                label="SMS"
                labelSize="xsmall"
                labelFor="notify_secretary_sms"
                name="notify.secretary.bySms"
                checked={
                  canEditForm
                    ? values.notify.secretary?.bySms
                    : finishedOrder?.notify?.secretary?.is_notify_phone
                }
                onChange={handleChange}
                disabled={!canEditForm}
              />
            </S.CheckboxWrapper>
            <TextFieldNew
              placeholder="(31)99999-9999"
              mask={phoneMask}
              id="fone"
              error={touched.phone?.secretary && errors.phone?.secretary}
              name="phone.secretary"
              onChange={handleChange}
              onBlur={handleBlur}
              defaultValue={
                canEditForm
                  ? values.phone?.secretary
                  : finishedOrder?.notify?.secretary?.phone
              }
              disabled={!canEditForm}
            />
          </S.InputBlock>
        </S.ProfileWrapper>
        <hr />
      </S.OrderContainer>
    </>
  )
}

const AuthorizationStatusSelection = ({ canEditForm }: any) => {
  const { values, setFieldValue, touched, errors } =
    useFormikContext<FinishOrderFormValues>()

  return (
    <>
      <S.OrderContainer>
        <S.GreenLabel>Status da autorização</S.GreenLabel>

        <SelectFieldNew
          style={{ width: '100%', maxWidth: '350px', marginBottom: '16px' }}
          placeholder="Selecione"
          label="Status da autorização"
          name="active_status"
          items={[
            {
              label: 'Autorizado',
              value: AuthorizationStatusTranslated.AUTHORIZED
            },
            {
              label: 'Autorizado com divergência',
              value: AuthorizationStatusTranslated.PARTIALLY_AUTHORIZED
            },
            {
              label: 'Negado',
              value: AuthorizationStatusTranslated.DENIED
            }
          ]}
          value={values.active_status}
          onInputChange={(value) => setFieldValue('active_status', value)}
          disabled={!canEditForm}
          required
          error={touched.active_status && errors.active_status}
        />
      </S.OrderContainer>
    </>
  )
}

const PasswordInputs = ({ canEditForm, finishedOrder, fromHistory }: any) => {
  const { values, handleChange, errors, touched, handleBlur, setFieldValue } =
    useFormikContext<FinishOrderFormValues>()

  const [showCalendar, setShowCalendar] = useState<boolean>(false)

  const toggleCalendar = () => {
    setShowCalendar(showCalendar !== true)
  }

  const changeDate = (date: any) => {
    if (moment(date).isValid()) {
      setFieldValue(
        'passwordValidUntil.date',
        moment(date).format('DD/MM/YYYY')
      )
      toggleCalendar()
    } else setFieldValue('passwordValidUntil.date', '')
  }

  const dataHistory =
    fromHistory && !finishedOrder.is_active
      ? moment(finishedOrder?.password_max_date_validation).format('DD/MM/YYYY')
      : values.passwordValidUntil.date

  const passwordValue =
    fromHistory && !finishedOrder.is_active
      ? finishedOrder?.password_to_finish
      : values.password

  return (
    <>
      <S.GreenLabel>Senha</S.GreenLabel>
      <S.OrderContainer>
        <S.PasswordWrapper>
          <TextFieldNew
            label="Senha"
            placeholder="Digite a senha"
            name="password"
            error={touched.password && errors.password}
            onChange={handleChange}
            onBlur={handleBlur}
            value={passwordValue}
            disabled={!canEditForm}
          />

          <div>
            <TextFieldNew
              label="Validade da Senha"
              placeholder="Selecione uma data"
              name="passwordValidUntil.date"
              mask={dateMask}
              icon={<DateRange />}
              iconPosition="insideRight"
              iconIsButton={true}
              onIconClick={() => toggleCalendar()}
              onChange={handleChange}
              error={
                touched.passwordValidUntil?.date &&
                errors.passwordValidUntil?.date
              }
              onBlur={handleBlur}
              value={dataHistory}
              disabled={!canEditForm}
            />

            <S.StyledCalendar
              show={showCalendar}
              value={null}
              onDateChange={(date) => changeDate(date)}
              minDate={moment().toDate()}
            />
          </div>
          <TextFieldNew
            style={{ flex: 1, minWidth: '280px' }}
            label="&nbsp;"
            placeholder="Ou digite a validade aqui"
            name="passwordValidUntil.text"
            onChange={handleChange}
            error={
              touched.passwordValidUntil?.text &&
              errors.passwordValidUntil?.text
            }
            onBlur={handleBlur}
            value={
              canEditForm
                ? values.passwordValidUntil.text
                : finishedOrder?.password_max_string_validation
            }
            disabled={!canEditForm}
          />
        </S.PasswordWrapper>
        <hr />
      </S.OrderContainer>
    </>
  )
}

const GuidesSectionProcedures = ({
  canEditForm,
  fromHistory,
  finishedOrder
}: any) => {
  const { handleChange, errors, values, touched, handleBlur } =
    useFormikContext<FinishOrderFormValues>()

  return (
    <>
      {fromHistory
        ? !!finishedOrder && (
            <>
              <S.GreenLabel>Procedimentos</S.GreenLabel>
              <S.OrderContainer>
                <GuidesItemsTable
                  type={'procedures'}
                  items={values?.procedures}
                />
                <S.InputBlock>
                  <S.TextDescription>
                    Observação sobre procedimentos
                  </S.TextDescription>
                  <TextArea
                    rows={5}
                    placeholder="Observação sobre procedimentos"
                    name="proceduresObservation"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={
                      canEditForm
                        ? values.proceduresObservation
                        : finishedOrder?.procedure_observation
                    }
                    disabled={!canEditForm}
                  />
                </S.InputBlock>
                <hr />
              </S.OrderContainer>
            </>
          )
        : !!values?.procedures && (
            <>
              <S.GreenLabel>Procedimentos</S.GreenLabel>
              <S.OrderContainer>
                <GuidesItemsTable
                  type={'procedures'}
                  items={values?.procedures}
                />
                <S.InputBlock>
                  <S.TextDescription>
                    Observação sobre procedimentos
                  </S.TextDescription>
                  <TextArea
                    rows={5}
                    placeholder="Observação sobre procedimentos"
                    name="proceduresObservation"
                    onChange={handleChange}
                    error={
                      touched.proceduresObservation &&
                      errors.proceduresObservation
                    }
                    onBlur={handleBlur}
                    value={
                      canEditForm
                        ? values?.proceduresObservation
                        : finishedOrder?.procedure_observation
                    }
                    disabled={!canEditForm}
                  />
                </S.InputBlock>
                <hr />
              </S.OrderContainer>
            </>
          )}
    </>
  )
}

const GuidesItemsTable = ({ items, type }: any) => {
  return (
    <S.CustomTable>
      <tr>
        {type !== 'opme' && <th>Código TUSS</th>}
        <th>Descrição</th>
        <th>Quant.Autorizada</th>
        <th>Quant.Solicitada</th>
        {type === 'opme' && <th>Fornecedor</th>}
      </tr>
      <tbody>
        {items?.map((item: any, index: any) => {
          return (
            <tr key={index}>
              {type !== 'opme' && <td>{item.code}</td>}
              <td>{item.description}</td>
              <td>
                <S.BallSpan
                  redTag={
                    Number(item.quantity_authorization) !==
                    Number(item.quantity_solicitation)
                  }
                >
                  {item.quantity_authorization || 0}
                </S.BallSpan>
              </td>
              <td>
                <S.BallSpan
                  redTag={
                    Number(item.quantity_authorization) !==
                    Number(item.quantity_solicitation)
                  }
                >
                  {item.quantity_solicitation || 0}
                </S.BallSpan>
              </td>
              {type === 'opme' && <td>{item.provider}</td>}
            </tr>
          )
        })}
      </tbody>
    </S.CustomTable>
  )
}

const OpmeVerification = ({
  surgicalOrder,
  editMode,
  opme,
  setOpme,
  canEditForm,
  finishedOrder,
  finalizedOrders
}: any) => {
  useEffect(() => {
    setOpme(surgicalOrder.opme)
  }, [opme])

  const { setFieldValue, handleChange, values, touched, errors, handleBlur } =
    useFormikContext<FinishOrderFormValues>()

  return (
    <>
      <S.GreenLabel>OPME</S.GreenLabel>
      <S.OrderContainer>
        <S.TextDescription>
          OPME autorizado conforme solicitação médica?
        </S.TextDescription>
        <S.RadioContainer>
          <RadioButtonNew
            name={`OPME_AUTORIZADO ${finishedOrder?.finalize_surgical_order_id}`}
            showBackground={false}
            value={OPMEStatusTranslated.OPME_AUTORIZADO}
            label="Sim, OPME autorizado"
            labelFor={OPMEStatus.OPME_AUTORIZADO}
            data-testid="option-opme-authorized"
            onCheck={() =>
              setFieldValue(
                'opmeVerification',
                OPMEStatusTranslated.OPME_AUTORIZADO
              )
            }
            checked={
              editMode || finalizedOrders?.length === 0
                ? values.opmeVerification ===
                  OPMEStatusTranslated.OPME_AUTORIZADO
                : finishedOrder?.opme_details ===
                  OPMEStatusTranslated.OPME_AUTORIZADO
            }
            disabled={!canEditForm}
          />
          <RadioButtonNew
            name={`OPME_AUTORIZADO_COM_DIVERGENCIA ${finishedOrder?.finalize_surgical_order_id}`}
            showBackground={false}
            value={OPMEStatusTranslated.OPME_AUTORIZADO_COM_DIVERGENCIA}
            label="Sim, OPME autorizado com divergência"
            labelFor={OPMEStatus.OPME_AUTORIZADO_COM_DIVERGENCIA}
            data-testid="option-authorization_divergence"
            onCheck={() =>
              setFieldValue(
                'opmeVerification',
                OPMEStatusTranslated.OPME_AUTORIZADO_COM_DIVERGENCIA
              )
            }
            checked={
              editMode || finalizedOrders?.length === 0
                ? values.opmeVerification ===
                  OPMEStatusTranslated.OPME_AUTORIZADO_COM_DIVERGENCIA
                : finishedOrder?.opme_details ===
                  OPMEStatusTranslated.OPME_AUTORIZADO_COM_DIVERGENCIA
            }
            disabled={!canEditForm}
          />
          <RadioButtonNew
            name={`OPME_NEGADO ${finishedOrder?.finalize_surgical_order_id}`}
            showBackground={false}
            value={OPMEStatusTranslated.OPME_NEGADO}
            label="Não, OPME negado"
            labelFor={OPMEStatus.OPME_NEGADO}
            data-testid="option-authorization_denied"
            onCheck={() => setFieldValue('opmeVerification', 'OPME negado')}
            checked={
              editMode || finalizedOrders?.length === 0
                ? values.opmeVerification === OPMEStatusTranslated.OPME_NEGADO
                : finishedOrder?.opme_details ===
                  OPMEStatusTranslated.OPME_NEGADO
            }
            disabled={!canEditForm}
          />
          <RadioButtonNew
            name={`PEDIDO_SEM_OPME ${finishedOrder?.finalize_surgical_order_id}`}
            showBackground={false}
            value={OPMEStatusTranslated.PEDIDO_SEM_OPME}
            label="Pedido sem OPME"
            labelFor={OPMEStatus.PEDIDO_SEM_OPME}
            data-testid="option-no-opme"
            onCheck={() =>
              setFieldValue(
                'opmeVerification',
                OPMEStatusTranslated.PEDIDO_SEM_OPME
              )
            }
            checked={
              editMode || finalizedOrders?.length === 0
                ? values.opmeVerification ===
                  OPMEStatusTranslated.PEDIDO_SEM_OPME
                : finishedOrder?.opme_details ===
                  OPMEStatusTranslated.PEDIDO_SEM_OPME
            }
            disabled={!canEditForm}
          />
        </S.RadioContainer>

        {errors.opmeVerification && (
          <SupportTextNew
            style={{ margin: '8px 0 16px' }}
            color="danger300"
            size="xsmall"
          >
            {errors.opmeVerification}
          </SupportTextNew>
        )}

        {(values.opmeVerification === OPMEStatusTranslated.OPME_NEGADO ||
          values.opmeVerification ===
            OPMEStatusTranslated.OPME_AUTORIZADO_COM_DIVERGENCIA ||
          finishedOrder?.opme_details === OPMEStatusTranslated.OPME_NEGADO ||
          (finishedOrder?.opme_details ===
            OPMEStatusTranslated.OPME_AUTORIZADO_COM_DIVERGENCIA &&
            !canEditForm)) && (
          <S.InputBlock style={{ marginTop: '16px' }}>
            <S.TextDescription>Observação sobre OPME</S.TextDescription>
            <TextArea
              rows={5}
              placeholder="Descreva aqui sua observação"
              name="opmeObservation"
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.opmeObservation && errors.opmeObservation}
              value={
                canEditForm
                  ? values.opmeObservation
                  : finishedOrder?.opme_observation
              }
              disabled={!canEditForm}
            />
          </S.InputBlock>
        )}
      </S.OrderContainer>
    </>
  )
}

const GuidesSectionOpme = () => {
  const { values } = useFormikContext<FinishOrderFormValues>()

  return (
    <>
      {values?.opme?.length > 0 && (
        <S.OrderContainer>
          <GuidesItemsTable type={'opme'} items={values?.opme} />
          <hr />
        </S.OrderContainer>
      )}
    </>
  )
}

const DocumentAttachments = ({
  finishedOrder,
  fromHistory,
  canEditForm,
  editMode,
  surgicalOrder,
  loadSurgicalOrderDocument
}: any) => {
  const { values, setFieldValue, errors } =
    useFormikContext<FinishOrderFormValues>()
  const [showDocumentsModal, setShowDocumentsModal] = useState<boolean>(false)
  const handleChangeDocuments = (documents: DocumentItem[]) => {
    setFieldValue('documents_attached', documents)
  }

  const authorizationGuideDocument = getAuthorizationGuideDocument(
    finishedOrder?.document,
    surgicalOrder
  )

  const handleDownloadDocumentFile = async (
    document_id: number
  ): Promise<File> => {
    const surgicalOrderDocument = await loadSurgicalOrderDocument?.load(
      surgicalOrder?.surgical_order_id,
      document_id
    )
    if (surgicalOrderDocument) {
      return buildAuthorizationGuideFile(
        surgicalOrderDocument.data,
        surgicalOrderDocument.contentType,
        authorizationGuideDocument?.name
      )
    }
    return new File([''], '')
  }

  const getGuideLabel = () => {
    const currentStatus =
      finishedOrder?.active_status || surgicalOrder?.active_status

    switch (currentStatus) {
      case AuthorizationStatusTranslated.AUTHORIZED:
        return 'Guia autorizada'
      case AuthorizationStatusTranslated.PARTIALLY_AUTHORIZED:
        return 'Guia autorizada parcialmente'
      case AuthorizationStatusTranslated.DENIED:
        return 'Guia negada'
      default:
        return 'Guia da Operadora'
    }
  }

  const canSee = {
    hasExams: true
  }
  let surgicalOrderAuthorizationGuideDocuments: DocumentItem[]

  if (fromHistory) {
    surgicalOrderAuthorizationGuideDocuments = authorizationGuideDocument
      ? [authorizationGuideDocument]
      : [
          {
            file: '',
            type: '',
            document_id: null,
            label: '',
            thumbnail: '',
            created_at: ''
          }
        ]
  } else {
    if (editMode) {
      surgicalOrderAuthorizationGuideDocuments = values.documents_attached
    }
    surgicalOrderAuthorizationGuideDocuments = values.documents_attached
      ? values.documents_attached
      : [
          {
            file: '',
            type: '',
            document_id: null,
            label: '',
            thumbnail: '',
            created_at: ''
          }
        ]
  }

  return (
    <>
      <S.GreenLabel>Anexos</S.GreenLabel>
      <S.OrderContainer>
        <AdvancedButton
          label={getGuideLabel()}
          onClick={() => setShowDocumentsModal(true)}
          showAttachmentIcon
        />
        {showDocumentsModal && (
          <DocumentsAreaModal
            title={getGuideLabel()}
            canSee={canSee}
            defaultDocuments={surgicalOrderAuthorizationGuideDocuments}
            defaultDocumentsListType={documentAuthorizationGuide}
            isReviewOnly={false}
            defaultDocsOnly={!canEditForm}
            showDownloadIcon={
              canEditForm
                ? false
                : !!authorizationGuideDocument?.document_url ||
                  !!authorizationGuideDocument?.document_id
            }
            handleChangeDocuments={(documents: DocumentItem[]) =>
              handleChangeDocuments(documents)
            }
            handleDownloadDocument={handleDownloadDocumentFile}
            documentUrl={authorizationGuideDocument?.document_url}
            handleClose={() => setShowDocumentsModal(false)}
          />
        )}
        {errors.documents_attached && (
          <SupportTextNew color="danger300" size="xsmall">
            Upload de guia autorizada é obrigatório.
          </SupportTextNew>
        )}
        <hr />
      </S.OrderContainer>
    </>
  )
}

const GeneralObservations = ({ canEditForm, finishedOrder }: any) => {
  const { values, handleChange, errors, touched, handleBlur } =
    useFormikContext<FinishOrderFormValues>()

  return (
    <>
      <S.OrderContainer>
        <S.GreenLabel>Observações gerais</S.GreenLabel>
        <S.InputBlock>
          <S.TextDescription>Observações gerais</S.TextDescription>
          <TextArea
            rows={5}
            placeholder="Descreva aqui sua observação"
            name="generalObservations"
            error={touched.generalObservations && errors.generalObservations}
            onChange={handleChange}
            onBlur={handleBlur}
            value={
              canEditForm
                ? values.generalObservations
                : finishedOrder?.general_observation
            }
            disabled={!canEditForm}
          />
        </S.InputBlock>
      </S.OrderContainer>
    </>
  )
}

type FooterContainerProps = {
  surgicalOrder: SurgicalOrderModel
  finishedOrder: boolean
  canEditForm: boolean
  setCanEditForm: any
  finalizedOrders: any
  setIsLoading: (value: boolean) => void
  editMode: boolean
  setEditMode: (value: boolean) => void
}

const FooterContainer = ({
  surgicalOrder,
  finishedOrder,
  canEditForm,
  finalizedOrders,
  setCanEditForm,
  setEditMode,
  editMode
}: FooterContainerProps) => {
  const { handleSubmit, isSubmitting } =
    useFormikContext<FinishOrderFormValues>()
  const history = useHistory()

  const finalizedOrUpdatedByName =
    !!surgicalOrder.finalized?.lastUpdateUser &&
    surgicalOrder.finalized?.lastUpdateUser?.name
  const finalizedOrUpdatedByRole =
    !!surgicalOrder.finalized?.lastUpdateUser &&
    surgicalOrder.finalized?.lastUpdateUser?.role
  const finalizedOrUpdatedByDate = surgicalOrder.finalized?.updated_at

  function handleEditMode() {
    setCanEditForm(false)
    setEditMode(false)
  }
  return (
    <S.FooterContainer>
      {finishedOrder && (
        <S.EditedBy>
          <span className="profile">
            {getNameInitials(finalizedOrUpdatedByName || '')}
          </span>
          <div className="infos">
            <span className="author">
              Editado pela última vez por {finalizedOrUpdatedByName}
            </span>
            <div className="details">
              <span className="role">{finalizedOrUpdatedByRole}</span> •{' '}
              <span className="date">
                {moment(finalizedOrUpdatedByDate)
                  .utc()
                  .format(`DD [de] MMM[.] [de] YYYY [às] HH[h]mm`)}
              </span>
            </div>
          </div>
        </S.EditedBy>
      )}
      {(canEditForm || (!canEditForm && finalizedOrders?.length === 0)) &&
        surgicalOrder.active_status !==
          AuthorizationStatusTranslated.CANCELED &&
        surgicalOrder.active_status !== AuthorizationStatusTranslated.DONE && (
          <S.Buttons>
            <ButtonNew
              outlined
              onClick={
                !finishedOrder
                  ? history.goBack
                  : editMode
                  ? () => handleEditMode()
                  : history.goBack
              }
            >
              Cancelar
            </ButtonNew>
            <ButtonNew onClick={() => handleSubmit()} disabled={isSubmitting}>
              {!canEditForm
                ? 'Editar dados de finalização'
                : finishedOrder
                ? 'Reenviar dados de finalização'
                : 'Finalizar Pedido'}
            </ButtonNew>
          </S.Buttons>
        )}
    </S.FooterContainer>
  )
}

const FormSection = WithLoading(
  ({
    formik,
    canEditForm,
    setCanEditForm,
    surgicalOrder,
    opme,
    setOpme,
    loadSurgicalOrderDocument,
    finishedOrder,
    finalizedOrders,
    fromHistory,
    setIsLoading,
    editMode,
    setEditMode
  }: any) => {
    // ToDo: Analisar essa condicional, ocasionou problemas (loading infinito)
    // if (!finishedOrder) {
    //   setIsLoading(true)
    // } else {
    //   setIsLoading(false)
    // }
    setIsLoading(false)

    //return finishedOrder ||
    //   surgicalOrder.active_status ===
    //   SurgicalOrderStatus.CANCELLATION_REQUEST || SurgicalOrderStatus.IN_HEALTH_INSURANCE ? (

    return (
      <>
        <FormikProvider value={formik}>
          <NotificationOptions
            fromHistory={fromHistory}
            canEditForm={canEditForm}
            finishedOrder={finishedOrder}
          />
          <AuthorizationStatusSelection canEditForm={canEditForm} />
          <PasswordInputs
            canEditForm={canEditForm}
            finishedOrder={finishedOrder}
            fromHistory={fromHistory}
          />
          <GuidesSectionProcedures
            canEditForm={canEditForm}
            finishedOrder={finishedOrder}
            fromHistory={fromHistory}
          />
          <OpmeVerification
            surgicalOrder={surgicalOrder}
            opme={opme}
            setOpme={setOpme}
            canEditForm={canEditForm}
            finishedOrder={finishedOrder}
            fromHistory={fromHistory}
            editMode={editMode}
            finalizedOrders={finalizedOrders}
          />
          <GuidesSectionOpme />
          <DocumentAttachments
            surgicalOrder={surgicalOrder}
            finishedOrder={finishedOrder}
            canEditForm={canEditForm}
            fromHistory={fromHistory}
            editMode={editMode}
            setIsLoading={setIsLoading}
            loadSurgicalOrderDocument={loadSurgicalOrderDocument}
          />
          <GeneralObservations
            canEditForm={canEditForm}
            finishedOrder={finishedOrder}
            fromHistory={fromHistory}
          />
          <FooterContainer
            surgicalOrder={surgicalOrder}
            finishedOrder={finishedOrder}
            canEditForm={canEditForm}
            setCanEditForm={setCanEditForm}
            setIsLoading={setIsLoading}
            editMode={editMode}
            setEditMode={setEditMode}
            finalizedOrders={finalizedOrders}
          />
        </FormikProvider>
      </>
    )
    // ) : (
    //   <></>
    // )
  }
)

const AllFinishedOrders = ({
  formik,
  canEditForm,
  setCanEditForm,
  surgicalOrder,
  finalizedOrders,
  opme,
  setOpme,
  loadSurgicalOrderDocument,
  setIsLoading,
  order
}: any) => {
  const items = finalizedOrders
    ?.map((finishedOrder: any) => {
      return {
        title: (
          <AccordionTab
            finishedOrder={finishedOrder}
            finalizedOrders={finalizedOrders}
            surgicalOrder={surgicalOrder}
            order={order}
          />
        ),
        content: (
          <FormSection
            fromHistory={true}
            formik={formik}
            canEditForm={canEditForm}
            setCanEditForm={setCanEditForm}
            surgicalOrder={surgicalOrder}
            opme={opme}
            setOpme={setOpme}
            loadSurgicalOrderDocument={loadSurgicalOrderDocument}
            finishedOrder={finishedOrder}
            finalizedOrders={finalizedOrders}
            setIsLoading={setIsLoading}
          />
        )
      }
    })
    .reverse()

  // const items = [
  //   {
  //     title: <AccordionTab />,
  //     content: (
  //       <FormSection
  //         fromHistory={true}
  //         formik={formik}
  //         canEditForm={canEditForm}
  //         setCanEditForm={setCanEditForm}
  //         surgicalOrder={surgicalOrder}
  //         opme={opme}
  //         setOpme={setOpme}
  //         loadSurgicalOrderDocument={loadSurgicalOrderDocument}
  //         finishedOrder={finishedOrder}
  //       />
  //     )
  //   },
  //   {
  //     title: <AccordionTab />,
  //     content: <AccordionTab />
  //   },
  //   {
  //     title: <AccordionTab />,
  //     content: <AccordionTab />
  //   }
  // ]

  return (
    <>
      <SupportTextNew weight="semiBold" size="xlarge" color="neutral800">
        Todas Finalizações
      </SupportTextNew>

      <AccordionTest items={items} padding="0px" />

      <S.LineAccordionDivider />
    </>
  )
}

const AccordionTab = ({ finishedOrder, finalizedOrders, order }: any) => {
  const finalizedOrUpdatedByName = !!finishedOrder && finishedOrder?.user.name
  const finalizedOrUpdatedByRole = !!finishedOrder && finishedOrder?.user.role

  return (
    <>
      <S.AccordionTab>
        <div>
          {(finishedOrder?.is_active || finalizedOrders?.length === 1) && (
            <>
              <SupportTextNew
                weight="semiBold"
                size="xsmall"
                color="primary800"
              >
                Última atualização
              </SupportTextNew>

              <SupportTextNew
                weight="semiBold"
                size="xsmall"
                color="neutral400"
              >
                |
              </SupportTextNew>
            </>
          )}

          <SupportTextNew weight="semiBold" size="xsmall" color="neutral900">
            {order?.status}
          </SupportTextNew>
        </div>

        <div
          style={{
            display: 'flex',
            marginLeft:
              finishedOrder?.is_active ||
              (finalizedOrders?.length !== 1 && '7px')
          }}
        >
          <SupportTextNew size="xsmall" weight="normal">
            {finishedOrder?.is_active || finalizedOrders?.length === 1 ? (
              <span>&nbsp; </span>
            ) : (
              ''
            )}
            {finishedOrder?.is_active || finalizedOrders?.length === 1
              ? ' Finalizado por: '
              : 'Editado por: '}
            &nbsp;
            {finalizedOrUpdatedByRole === Profile.DOCTOR && 'Dr.(a) '}
            {finalizedOrUpdatedByName} em{' '}
            {moment(finishedOrder?.created_at)
              .utc()
              .format(`DD [de] MMM[.] [de] YYYY [às] HH[h]mm`)}
          </SupportTextNew>
        </div>
      </S.AccordionTab>
    </>
  )
}
